export default __webpack_public_path__ + "static/media/successTick.2966077b.svg";